class BundleBuilderWidget extends HTMLElement {
  connectedCallback() {
    this.anchorVariantId = this.dataset.anchorVariant;
    this.anchorPrice = parseInt(this.dataset.anchorPrice || '0', 10);
    this.anchorTitle = this.dataset.anchorTitle;
    this.discountThreshold = parseInt(this.dataset.discountThreshold || '2', 10);
    this.discountPercent = parseInt(this.dataset.discountPercent || '0', 10);

    this.cards = Array.from(this.querySelectorAll('[data-bundle-card]'));
    this.summaryList = this.querySelector('[data-summary-list]');
    this.subtotalEl = this.querySelector('[data-subtotal]');
    this.savingsRow = this.querySelector('[data-savings-row]');
    this.savingsEl = this.querySelector('[data-savings]');
    this.addButton = this.querySelector('[data-bundle-add]');
    this.status = this.querySelector('[data-bundle-status]');
    this.currencyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'fr-MA', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    this.cards.forEach((card) => {
      const checkbox = card.querySelector('[data-bundle-checkbox]');
      const select = card.querySelector('[data-bundle-variant-select]');
      checkbox.addEventListener('change', () => this.updateSummary());
      if (select) select.addEventListener('change', () => this.updateSummary());
    });

    this.addButton.addEventListener('click', () => this.addBundleToCart());
    this.updateSummary();
  }

  getCardSelection(card) {
    const select = card.querySelector('[data-bundle-variant-select]');
    if (select) {
      const option = select.options[select.selectedIndex];
      return { variantId: option.value, price: parseInt(option.dataset.price, 10) };
    }
    const hidden = card.querySelector('[data-bundle-single-variant]');
    return { variantId: hidden.dataset.bundleSingleVariant, price: parseInt(hidden.dataset.price, 10) };
  }

  getSelectedItems() {
    return this.cards
      .filter((card) => card.querySelector('[data-bundle-checkbox]').checked)
      .map((card) => ({ title: card.querySelector('.bundle-builder__card-title').textContent, ...this.getCardSelection(card) }));
  }

  updateSummary() {
    const selected = this.getSelectedItems();
    this.summaryList.querySelectorAll('[data-bundle-summary-row]').forEach((row) => row.remove());
    selected.forEach((item) => {
      const li = document.createElement('li');
      li.className = 'bundle-builder__summary-item';
      li.setAttribute('data-bundle-summary-row', '');
      li.innerHTML = `<span>${item.title}</span><span>${this.currencyFormatter.format(item.price / 100)} dh</span>`;
      this.summaryList.appendChild(li);
    });

    const itemCount = 1 + selected.length;
    const rawTotal = this.anchorPrice + selected.reduce((sum, item) => sum + item.price, 0);
    let finalTotal = rawTotal;
    let savings = 0;

    if (itemCount >= this.discountThreshold && this.discountPercent > 0) {
      savings = Math.round((rawTotal * this.discountPercent) / 100);
      finalTotal = rawTotal - savings;
    }

    this.subtotalEl.textContent = `${this.currencyFormatter.format(finalTotal / 100)} dh`;
    if (savings > 0) {
      this.savingsRow.hidden = false;
      this.savingsEl.textContent = `-${this.currencyFormatter.format(savings / 100)} dh`;
    } else {
      this.savingsRow.hidden = true;
    }

    this.addButton.textContent = `Ajouter la tenue au panier — ${this.currencyFormatter.format(finalTotal / 100)} dh`;
  }

  getAnchorVariantId() {
    const form = document.querySelector('product-form form, form[action*="/cart/add"]');
    if (form) {
      const input = form.querySelector('[name="id"]');
      if (input && input.value) return input.value;
    }
    return this.anchorVariantId;
  }

  async addBundleToCart() {
    const selected = this.getSelectedItems();
    const items = [{ id: parseInt(this.getAnchorVariantId(), 10), quantity: 1 }];
    selected.forEach((item) => items.push({ id: parseInt(item.variantId, 10), quantity: 1 }));

    this.addButton.setAttribute('disabled', 'disabled');
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items }),
      });
      if (!response.ok) throw new Error('add_failed');
      window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
    } catch (error) {
      this.status.hidden = false;
      this.status.textContent = "Impossible d'ajouter la tenue au panier.";
      this.addButton.removeAttribute('disabled');
    }
  }
}

customElements.define('bundle-builder-widget', BundleBuilderWidget);
